import {
  Colors,
  extendTheme,
  ThemeComponents,
  ThemeConfig,
  withDefaultColorScheme,
  withDefaultSize,
} from '@chakra-ui/react';

const colors: Colors = {
  // Base color: #2C4142. Generated by https://smart-swatch.netlify.app
  easeMobile: {
    50: '#e6f8f8',
    100: '#cee1e1',
    200: '#b3cbcc',
    300: '#96b6b7',
    400: '#79a0a2',
    500: '#608789',
    600: '#49696b',
    700: '#334b4d',
    800: '#1c2e2f',
    900: '#001111',
  },
  lightestGreen: '#cbdec04d',
  lightestGold: '#ffdd6433',
  lightestRed: '#f66c4e4d',
  lightestGrey: '#e5e5e580',
  primaryBackground: '#eef5f4',
  baseColor: '#2c4142',
  toggleBgColor: '#4576721A',
  fadedJade: '#457672',
  liteOuter: '#2C4142CC', // outer space with 0.8 opacity
  borderColor: '#f1f1f1',
  blackSecondary: '#647576',
  lightGrey: '#A0B2B4',
  dark: '#3B4256',
  greenLight: '#B2BFB3',
  graySecondary: '#6F7482',
  darkCream: '#F1EEE4',
  surfaceLight: '#F8FAFC',
};

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const shadows = {
  outline: '0 0 0 3px #49696b',
};

const styles = {
  global: {
    // styles for the `body`
    body: {
      bg: 'primaryBackground',
      color: 'baseColor',
      fontSize: '14px',
      fontFamily: 'Inter',
      fontWeight: 'normal',
    },
  },
};

const fonts = 'Inter';

const components: ThemeComponents = {
  Button: {
    baseStyle: {
      borderRadius: 6,
      outline: 'none',
    },
    sizes: {
      sm: {
        minW: '100px',
        minHeight: '48px',
        fontWeight: 'bold',
      },
    },
    variants: {
      primary: {
        bg: 'baseColor',
        color: 'white',
      },
      outline: {
        borderColor: 'baseColor',
        color: 'baseColor',
      },
      toggle: {
        borderRadius: '48px',
        bg: 'toggleBgColor',
      },
      white: {
        minW: 'auto',
      },
      solid: {
        borderRadius: '48px',
        bg: 'fadedJade',
        color: 'white',
        _hover: {bg: 'fadedJade'},
      },
      outlinePrimary: {
        color: 'fadedJade',
        borderWidth: '1px',
        borderColor: 'fadedJade',
        borderRadius: '50px',
      },
      nonFocus: {
        _focus: {
          boxShadow: 'none',
        },
      },
    },
  },
  Card: {
    baseStyle: {
      display: 'flex',
      flexDirection: 'column',
      background: 'white',
      alignItems: 'center',
      gap: 6,
    },
    // Two variants: rounded and smooth
    variants: {
      rounded: {
        padding: 8,
        borderRadius: 'xl',
        boxShadow: 'xl',
      },
      smooth: {
        padding: 6,
        borderRadius: 'base',
        boxShadow: 'md',
      },
    },
    // The default variant value
    defaultProps: {
      variant: 'smooth',
    },
  },
  Text: {
    variants: {
      mdqTitle: {
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '28px',
      },
    },
  },
};
export const uiTheme = extendTheme(
  {colors, config, components, shadows, styles, fonts},
  withDefaultColorScheme({colorScheme: 'easeMobile'}),
  withDefaultSize({size: 'sm'}),
);
